if (window.location.pathname === '/en/pages/galerie-1') {
  var texts = document.querySelectorAll('[data-pf-type="Text"]');
  if (texts.length >= 6) {
    texts[0].innerText = "Gallery";
    texts[1].innerHTML = "Please find here the examples of our achievements of cakes.<br/>Don't hesitate to ask us for a quote if you like any of them.";
    texts[2].innerHTML = "Request a quote";
    texts[3].innerHTML = "OUR EXAMPLES OF THEME CAKES";  
    texts[4].innerHTML = "OUR EXAMPLES OF CAKES<br/>BABY SHOWER & GENDER REVEAL";  
    texts[5].innerHTML = "OUR EXAMPLES OF MOUNTED PARTS"; 
  }
  var link = document.querySelector('[href="/pages/formulaire-de-devis"]');
  if (link) {
  	link.setAttribute("href", "/en/pages/request-a-quote");
  }
}